export default __webpack_public_path__ + "static/media/vozik_thumbnail.540ea169.png";